<template>
  <div class="app">
    <nav class="navbar navbar-expand-md navbar-light">
      <div class="container">
        <router-link class="navbar-brand" :to="{ name: 'home' }">
          <img alt="AUTO PS - Naprawy blacharsko - lakiernicze" src="@/assets/logo-dark.svg" />
        </router-link>

        <div class="order-md-1">
          <a class="d-inline-block px-sm-2 text-decoration-none" href="tel:+48790025244"
            ><i class="fa fa-phone fa-fw align-bottom"></i
            ><span class="ml-1 d-none d-lg-inline">790 025 244</span></a
          >
          <a
            class="d-inline-block px-sm-2 text-decoration-none"
            href="https://www.google.pl/maps/dir//AUTO+PS+-+Naprawy+blacharsko+-+lakiernicze,+Syreny+14,+01-132+Warszawa/"
            rel="nofollow"
            ><i class="fa fa-map-marker fa-fw align-bottom"></i
            ><span class="ml-1 d-none d-lg-inline">Warszawa, Syreny 14</span></a
          >
          <a
            class="d-inline-block px-sm-2 text-decoration-none"
            href="mailto:autops.syreny14@gmail.com"
            ><i class="fa fa-envelope-o fa-fw align-bottom"></i
            ><span class="ml-1 d-none d-lg-inline">autops.syreny14@gmail.com</span></a
          >
        </div>
      </div>
    </nav>

    <main role="main">
      <router-view />
    </main>

    <footer>
      <div class="bg-dark text-light">
        <div class="container py-2 d-flex align-items-center">
          <img
            alt="AUTO PS - Bezgotówkowe naprawy powypadkowe"
            class="footer-logo mr-1"
            src="@/assets/brand-name-light.svg"
          />
          <p class="mb-0">
            &copy; {{ new Date().getFullYear() }} &bullet;
            <router-link :to="{ name: 'cookies' }">Polityka cookies</router-link>
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<style lang="scss" scoped>
i.fa {
  font-size: 1.5rem;
}

.footer-logo {
  height: 14px;
}
</style>
